var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SingleDocAlertModal from '@web/components/DocAlerts/SingleDocAlertModal';
import { DriveDocumentEventsLog } from '@web/components/ItemDetails/DriveItemDetails/DriveDocumentEventsLog';
import { DriveItemNav } from '@web/components/ItemDetails/DriveItemDetails/DriveItemNav';
import { DriveTimeline } from '@web/components/ItemDetails/DriveItemDetails/DriveTimeline';
import { FileSummary } from '@web/components/ItemDetails/DriveItemDetails/FileSummary';
import { PeopleActivity } from '@web/components/ItemDetails/DriveItemDetails/PeopleActivity';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { Widget } from '@web/components/layout/Widget';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import Heatmap from '@web/components/ui/charts/Heatmap';
import { trpc } from '@web/lib/trpc';
import NotFoundView from '@web/pages/layout/NotFoundView/NotFoundView';
import { isAiButtonDisabled } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { InsightTypeEnum } from '@workalizer/shared';
import { format } from 'date-fns';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export var DriveItemDetails = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var t = useTranslation().t;
    var itemId = useFilters().itemId;
    var navigateTo = useNavigateTo();
    var _k = useState(false), isVisibleModal = _k[0], setIsVisibleModal = _k[1];
    var _l = trpc.documentItemHeader.useQuery({
        documentId: Number(itemId)
    }), header = _l.data, isHeaderLoading = _l.isLoading;
    var _m = trpc.documentYearlyActivity.useQuery({
        documentId: (_a = header === null || header === void 0 ? void 0 : header.id) !== null && _a !== void 0 ? _a : 0
    }, {
        enabled: !!(header === null || header === void 0 ? void 0 : header.id)
    }), documentActivity = _m.data, refetchDocumentActivity = _m.refetch;
    if (isHeaderLoading || (header && !documentActivity)) {
        return _jsx(Loading, {});
    }
    if (!header || !documentActivity) {
        return _jsx(NotFoundView, {});
    }
    var onActivityCellClick = function (value) {
        if (!(value === null || value === void 0 ? void 0 : value.date)) {
            return;
        }
        var clickedDate = typeof value.date === 'string'
            ? value.date.slice(0, 10)
            : format(value.date, 'yyyy-MM-dd');
        navigateTo({
            newFilters: {
                driveHeatmapDate: clickedDate,
                driveTimelineDate: clickedDate
            }
        });
    };
    return (_jsxs("div", { children: [_jsx(DriveItemNav, { header: header, setIsVisibleModal: setIsVisibleModal }), _jsxs("div", __assign({ className: "space-y-20 mt-10" }, { children: [_jsx(FileSummary, { documentId: header.id }), _jsx(SingleDocAlertModal, { visible: isVisibleModal, onClose: function () { return setIsVisibleModal(false); }, document: {
                            id: header.id,
                            title: header.title,
                            type: header.type,
                            slugId: header.slugId,
                            workspaceId: 0,
                            ownerId: (_c = (_b = header.owner) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null,
                            createdAt: (_e = (_d = header.created) === null || _d === void 0 ? void 0 : _d.date) !== null && _e !== void 0 ? _e : new Date().toISOString(),
                            updatedAt: (_j = (_g = (_f = header.lastActivity) === null || _f === void 0 ? void 0 : _f.date) !== null && _g !== void 0 ? _g : (_h = header.lastViewed) === null || _h === void 0 ? void 0 : _h.date) !== null && _j !== void 0 ? _j : new Date().toISOString()
                        } }), _jsxs("div", { children: [_jsx(WidgetTitle, { title: t('driveItemDetails.activityTrend'), description: "widgetTitleDescriptions.itemDetails.driveActivityTrend", insightType: InsightTypeEnum.documentActivity, insightsData: documentActivity, refetch: refetchDocumentActivity, csvExport: _jsx(ExportMenu, { fileName: t('driveItemDetails.activityTrend'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, (documentActivity !== null && documentActivity !== void 0 ? documentActivity : []).map(function (item) {
                                                    var _a;
                                                    return (_a = {},
                                                        _a[t('app.apps.searchMeetings.filters.date')] = item.date,
                                                        _a.Activity = item.count,
                                                        _a);
                                                })];
                                        });
                                    }); }, disabled: isAiButtonDisabled(documentActivity) }) }), _jsx(Widget, { children: _jsx(Heatmap, { values: documentActivity, showIntensityLegend: true, onCellClick: onActivityCellClick }) })] }), _jsx(DriveTimeline, { documentId: header.id }), _jsx(DriveDocumentEventsLog, { documentId: header.id }), _jsx(PeopleActivity, {})] }))] }));
};
